import { loc } from "../../../../core/utils"
import { bool, func, string } from "prop-types"
import React from "react"
import { Button, Col } from "react-bootstrap"
import { useMedia } from "react-use"

export default function BplsSummaryBottomFixedButtons({ shopUrl, goBackToClientPage, isSubmitDisabled, handleSubmit }) {
  const isBelowTablet = useMedia("(max-width: 768px)")

  return (
    <>
      <Col
        lg={{ span: 3, order: 1 }}
        md={{ span: 4, order: 1 }}
        xs={{ span: 6, order: 2 }}
        className="align-item-start"
      >
        <Button
          variant="outline-primary"
          onClick={goBackToClientPage}
          className="h-100 btn-outline-primary btn ico-edit-small-before"
        >
          {loc`modifier_donnees`}
        </Button>
      </Col>
      <Col
        lg={{ span: 4, order: 2 }}
        md={{ span: 4, order: 2 }}
        xs={{ span: 12, order: 1 }}
        className={`h-100 align-item-center mr-auto ml-auto ${isBelowTablet ? "mb-2" : ""}`}
      >
        <Button variant="outline-primary" href={shopUrl}>
          {loc("button_back_shop")}
        </Button>
      </Col>

      <Col lg={{ span: 3, order: 3 }} md={{ span: 4, order: 3 }} xs={{ span: 6, order: 3 }} className="align-item-end">
        <Button
          id="continue"
          variant="success"
          type="button"
          className="h-100 btn-solid btn"
          disabled={isSubmitDisabled}
          onClick={handleSubmit}
        >
          {loc`Submit_BPLS`}
        </Button>
      </Col>
    </>
  )
}

BplsSummaryBottomFixedButtons.propTypes = {
  shopUrl: string,
  goBackToClientPage: func.isRequired,
  isSubmitDisabled: bool,
  handleSubmit: func.isRequired
}
